// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3eepS","colCheckbox":"styles_colCheckbox__2GPkI"};